import { Injectable } from '@angular/core';
import { HealthInsurance } from '../../classes/healthInsurance';

import { Auth } from '../auth.service';
import { RequestService } from '../request.service';
import { UserService } from '../users/user.service';

@Injectable()
export class HealthInsuranceService extends UserService{

  constructor(
    protected requestService: RequestService,
    protected auth: Auth
  ) { super(requestService, auth); }

  protected getUsersUrl(): string {

    return 'healthInsurances';
  };

  protected getOneUserUrl(): string {
    return 'healthInsurance';
  };

  protected parseObject(obj: any): HealthInsurance {

    return obj as HealthInsurance;
  };

  protected parseArray(objs: any): HealthInsurance[] {

    return objs as HealthInsurance[];
  };

  public createHealthInsuranceProvider(name): Promise<any> {
    return this.requestService.makeRequest({
      body: {
        name: name
      },
      method: 'post'
    }, '/healthInsurance')
    .then((response: any) => {
      return response._body;
    });
  }

  public getOne(id:string): Promise<any> {
    return this.requestService.makeRequest({
      method: 'get'
    }, '/healthInsurance/' + id)
    .then((response: any) => {
      return response._body;
    })
  }


  public getAll(): Promise<any> {
    return this.requestService.makeRequest({
      method: 'get',
      urlQueryParams: {limit:1000}
    }, '/healthInsurances')
    .then((response: any) => {
      return response._body;
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/services/healthInsurance/health.insurance.service.ts